import { render, staticRenderFns } from "./mt-checkbox.vue?vue&type=template&id=7d4fa3ca&"
import script from "./mt-checkbox.vue?vue&type=script&lang=js&"
export * from "./mt-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./mt-checkbox.vue?vue&type=style&index=0&id=7d4fa3ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports